export function CheckListIcon(): JSX.Element {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3332 6.27904H10.8332V7.9457H18.3332V6.27904ZM18.3332 12.9457H10.8332V14.6124H18.3332V12.9457ZM4.6165 9.61237L1.6665 6.66237L2.8415 5.48737L4.60817 7.25404L8.1415 3.7207L9.3165 4.8957L4.6165 9.61237ZM4.6165 16.279L1.6665 13.329L2.8415 12.154L4.60817 13.9207L8.1415 10.3874L9.3165 11.5624L4.6165 16.279Z"
        fill="currentColor"
      />
    </svg>
  );
}
